<template>
  <div class="file-view">
    <file-header
      v-if="!isMoreShare"
      v-show="!showSearchView && !hideFileHeader"
      :headerName="headerItem.name"
      :isFrequent="headerItem.is_frequently_used"
      :spaceClosed="spaceClosed"
      :listError="listInfo.error"
      :scenario="scenario"
      :isOpenIndex="isOpenIndex"
      :isExternalShare="isExternalShare"
      @item-change="onHeaderItemChange"
      @close-select="closeOpenSelector"
    />
    <van-tabs
      :line-width="20"
      color="#6ca2ff"
      v-if="showTabs"
      @change="handleTabClick"
      class="file-view-tabs"
      v-model="activeTabs"
    >
      <van-tab :title="$t('base.files')"></van-tab>
      <van-tab v-if="!config.university_account_status" :title="$t('collab.add.member') + collabList.length"></van-tab>
    </van-tabs>
    <!-- Tab collabs -->
    <file-collabs
      v-if="showTabs"
      @collabList-callback="collabListCallback"
      :headerItem="headerItem"
      :showTabs="showTabs"
      v-show="$route.query.tab === 'collab'"
    />
    <!-- FileNav 挪到外部防止 在tab = collab时不显示 -->
    <file-nav
      v-if="!isExternalShare"
      :show="showFileNav"
      :scenario="scenario"
      :isOpenIndex="isOpenIndex"
      @search-input-click="toggleSearch"
    />
    <div class="file-view-list" v-show="$route.query.tab !== 'collab'" :style="showSearchView ? 'z-index: 2' : ''">
      <!-- search header -->
      <search-sort
        v-if="!['trash'].includes($route.params.space) && !showSearchView && !spaceClosed && !listInfo.error && !(scenario === 'share' && !isExternalShare)"
        :isExternalShare="isExternalShare"
        :isMoreShare="isMoreShare"
        @search-input-click="toggleSearch"
        @sort-btn-click="handleShowSortAction"
      />
      <trash-filter
        v-if="$route.params.space === 'trash'"
        v-show="this.trashFilterList.length > 1"
        :trashFilterSelected="trashFilterSelected"
        :showActionSheet="showActionSheet && actionFrom === 'trash-filter'"
        @trash-filter-list = "handleReceiveTrashFilterList"
        @menu-click="handleShowTrashFilter"
      />
      <div>
      <van-notice-bar v-if="ua.wxwork && config.enterpirse_wxwork_guide_logout" @close="closeLogoutGuide" mode="closeable" >
      <!-- <van-notice-bar v-show=true @close="closeLogoutGuide" mode="closeable" > -->
        <i class="iconfont icon-info"/>
        <span @click="handleLogoutGuideClick">
          {{$t('notice.login.white')}}
        </span>
        <span class="notice-login-yellow" @click="handleLogoutGuideClick">
          {{$t('notice.login.yellow')}}
        </span>
      </van-notice-bar>
      <!-- 企业微信pc引导下载客户端 -->
      <van-notice-bar v-else-if="ua.wxwork && config.enterpirse_wxwork_guide_sync" @close="closeSyncGuide" mode="closeable" >
        <span @click="handleDonwloadSyncGuide">
          {{$t('share.guide.slogn')}}
        </span>
      </van-notice-bar>
      </div>
      <!-- search-view -->
      <file-list
        v-if=true
        v-show="!showSearchView || !(showSearchView && $route.params.space !== 'search')"
        :class="[showSearchView && 'search-result-list', showFileNav && 'disable-scroll']"
        :trashFilterSelected="trashFilterSelected"
        :uploadFiles="uploadFiles"
        :spaceClosed="spaceClosed"
        :scenario="scenario"
        :selectedFiles="selectedFiles"
        :permSave="permSave"
        :isExternalShare="isExternalShare"
        :isMoreShare="isMoreShare"
        :uniqueName="uniqueName"
        :fileListData="fileListData"
        :process="process"
        @list-info-change="onListInfoChange"
        @item-select-toggle="toggleSelect"
        @upload-click='uploadAction'
      />
      <div v-if="$route.params.module === 'select_files'" :class="openActionCls" @click="toggleShowSelectFiles">
        <div :class="['selected-count primary-color', selectDisabled && 'disabled']">{{ $t('file.selectedFiles') }}({{ selectedFiles.length }}{{selectFileMax ? `/${selectFileMax}` : ''}}) <i class="iconfont icon-arrow-down1"/></div>
        <button :class="['btn', 'primary-bgcolor', selectDisabled &&  'disabled']" :disabled="selectDisabled" @click.stop="sendSelectFiles">{{ confirmBtnText ? confirmBtnText : $t('base.select') }}({{ selectedFiles.length }}{{selectFileMax ? `/${selectFileMax}` : ''}})</button>
      </div>
      <div v-else-if="$route.params.module === 'select_destination' && headerItem.name && !showSearchView && !showCreateRename" :class="openActionCls">
        <div :class="['selected-count', !canCreateFolder && 'disabled']" @click="createFolder"> + {{ $t('file.create.folder') }}</div>
        <button :class="['btn', 'primary-bgcolor', 'btn-select-destination', 'ellipsis', selectDisabled && 'disabled']" :disabled="selectDisabled" @click.stop="sendSelectFolder">{{ $t('file.toTarget', [confirmBtnText ? confirmBtnText : $t('base.save'), headerItem.name]) }}</button>
      </div>
      <div v-if="plusActions.length > 0 " class="plus-action primary-bgcolor" @click="onPlusClick"><i class="iconfont icon-add1"></i></div>
      <!-- search -->
      <van-popup
        class="search-view file-search"
        v-if="showSearchView"
        v-model="showSearchView"
        position="bottom"
        :lazy-render="false"
        :overlay="false"
      >
        <search-view
          :show="showSearchView"
          :isOpenIndex="isOpenIndex"
          :selectedFiles="selectedFiles"
          @item-select-toggle="toggleSelect"
        />
      </van-popup>
      <!-- search-end -->
      <!-- search blank -->
    </div>
    <van-popup
      class="seleted-popup file-selected open_select_files"
      v-model="showSelectedFiles"
      position="bottom"
      :lazy-render="false"
      :overlay="false"
    >
      <selected-files
        v-model="selectedFiles"
        @item-select-toggle="toggleShowSelectFiles"
      />
    </van-popup>
  </div>
</template>

<script>
import config from '@/config'
import {i18n} from '@/utils/i18n'
import FileNav from './FileNav'
import FileHeader from './FileHeader'
import FileList from './FileList'
import FileItem from './FileItem'
import FrequentItem from './FrequentItem'
import TrashFilter from './TrashFilter'
import SearchSort from './SearchSort'
import SearchView from './SearchView'
import SelectedFiles from './SelectedFiles'
import {triggerUploadFile} from '@/utils/fileUtils'
import {sortByMap, updateUserGuideSetting, ua, fileViewReservedQuery, openPlatformCallback, setDocumentTitle} from '@/utils/common'
import FileCollabs from './FileCollabs'
import store from '../../store/index'

export default {
  name: 'FileView',
  i18n,
  components: {
    FileNav,
    FileHeader,
    FileList,
    FileItem,
    FrequentItem,
    TrashFilter,
    SearchSort,
    SearchView,
    SelectedFiles,
    FileCollabs
  },
  props: {
    isExternalShare: Boolean,
    hideFileHeader: Boolean,
    permSave: Boolean,
    isMoreShare: Boolean,
    uniqueName: String,
    process: Object,
    fileListData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    const { query, params, name } = this.$route
    const isOpenIndex = name === 'OpenView' && !params.space && !params.id

    return {
      actionFrom: '',
      actionName: '',
      showActionSheet: false,
      showFileNav: isOpenIndex,
      showSearchView: !!query.search,
      showCreateRename: !!query.createrename,
      showSelectedFiles: false,
      actionItem: {},
      headerItem: {},
      listInfo: {},
      trashFilterSelected: params.id || 'my_0', // 默认是我的企业
      trashFilterList: [],
      uploadFiles: {},
      selectedFiles: [],
      scenario: this.isExternalShare ? 'share' : query.scenario,
      isOpenIndex,
      confirmBtnText: config.openConfig.confirmBtnText,
      selectFileMax: config.openConfig.selectFileMax,
      config,
      ua,
      isRootDir: params.space === 'own',
      collabList: '', // 协作tab 列表信息
      activeTabs: ''
    }
  },
  computed: {
    canCreateFolder () {
      const { permissions } = this.headerItem
      return permissions && (permissions.includes('create_folder') || permissions.includes('item_upload'))
    },
    canUpload () {
      let { permissions } = this.headerItem
      return !!(permissions && permissions.includes('item_upload'))
    },
    plusActions () {
      if (this.showSearchView || this.spaceClosed || this.scenario === 'share' || this.$route.name === 'OpenView' || this.listInfo.error) {
        return []
      }
      // 除了个人空间，其他空间(协作、回收站等)不能新建文件夹
      const actions = []
      if (this.canCreateFolder) {
        actions.push({
          key: 'create-folder',
          name: i18n.t('file.create.folder'),
          leftIcon: 'new-folder',
          callback: this.createFolder
        })
      }

      // 除个人空间根目录，其它控件根目录无“上传文件”操作
      if (this.canUpload) {
        actions.push({
          key: 'upload-file',
          name: i18n.t('file.upload.file'),
          leftIcon: 'upload',
          callback: this.uploadAction
        })
      }
      return actions
    },
    sortActions () {
      let sortInfo = this.store.sortInfo
      let mySortByMap = sortByMap
      if (this.isExternalShare) {
        // 外部分享名字靠前
        mySortByMap = {
          name_asc: 'file.sort.nameAsc',
          name_desc: 'file.sort.nameDesc',
          date_asc: 'file.sort.dateAsc',
          date_desc: 'file.sort.dateDesc',
          size_asc: 'file.sort.sizeAsc',
          size_desc: 'file.sort.sizeDesc'
        }
      }
      const actions = Object.keys(mySortByMap).map(key => {
        return {
          className: sortInfo === key ? 'active ' : '',
          key,
          name: i18n.t(mySortByMap[key]),
          callback: () => {
            this.saveSortInfo(key)
          }
        }
      })
      return actions
    },
    uploadTarget () {
      let { typed_id, isDepartment } = this.headerItem

      let [space, id] = (typed_id || '').split('_')
      if (isDepartment) {
        space = 'dept'
      }

      let uploadTarget = null
      if (this.canUpload) {
        switch (space) {
          case 'dept':
          case 'folder':
            uploadTarget = `${space}_${id}`
            break
          case 'own':
            uploadTarget = 'folder_0'
            break
        }
      } else {
        switch (space) {
          case 'folder':
          case 'collab':
          case 'external':
            uploadTarget = 'illegal'
            break
        }
      }

      return uploadTarget
    },
    spaceClosed () {
      const {space} = this.$route.params
      return space === 'own' && config.enterprise_info.is_personal_space_closed
    },
    selectDisabled () {
      return (this.$route.params.module === 'select_files' && this.selectedFiles.length === 0) ||
      (this.$route.params.module === 'select_destination' && (!this.canUpload || (this.headerItem.typed_id !== 'own_0' && (this.headerItem.type !== 'folder' || !this.headerItem.id))))
      // 选择目标目录 必须有上传权限 目标目录不是空间 必须是文件夹
    },
    openActionCls () {
      return ['select-action', this.showSearchView && 'in-search']
    },
    showTabs () {
      const {space, id} = this.$route.params
      const {owned_by: {is_personal_user} = {}} = this.headerItem

      // id == this.headerItem.id 外部是文件夹，内部是协作文件夹的时候不会先出现tab 后消失情况
      // return this.scenario !== 'share' && !is_personal_user && !this.isRootDir && !is_external_collab_folder && (id == this.headerItem.id) && space === 'folder'
      // eslint-disable-next-line eqeqeq
      return this.scenario !== 'share' && !is_personal_user && !this.isRootDir && (id == this.headerItem.id) && space === 'folder' && this.$route.params.module != 'select_files'
    }
  },
  watch: {
    $route (to, from) {
      this.showFileNav = !!to.query.filenav || (to.name === 'OpenView' && !to.params.space && !to.params.id)
      this.showSearchView = !!to.query.search
      this.showCreateRename = !!to.query.createrename
      this.trashFilterSelected = to.params.id || 'my_0'
      this.isOpenIndex = to.name === 'OpenView' && !to.params.space && !to.params.id
      this.toggleOpenFileNav()
      this.isRootDir = to.params.space === 'own'
      this.activeTabs = this.$route.query.tab === 'collab' ? 1 : 0
      // 只在有tabs 且当前文件夹的folderId 不一样时 请求collabList
      const folderId = this.$route.params.id

      this.folderId = folderId
    },
    selectedFiles (value) {
      if (value.length <= 0) {
        this.showSelectedFiles = false
      }
    }
  },
  beforeCreate () {
    const query = this.$route.query
    if (!Object.keys(query).length) {
      if (this.$route.path === '/files/frequent') {
        this.$router.push({ query: {filenav: 1} })
      }
      return
    }
    const reservedQuery = fileViewReservedQuery
    const newQuery = {}
    reservedQuery.forEach(item => {
      newQuery[item] = query[item]
    })
    if (this.$route.path === '/files/frequent') {
      newQuery.filenav = 1
    }
    this.$router.replace({ query: newQuery })
  },
  created () {
    this.toggleOpenFileNav()
    this.showFileNav = !!this.$route.query.filenav
  },
  methods: {
    handleSendGuideRequest () {
      if (this.config.enterpirse_wxwork_guide_sync) {
        return new Promise((resolve) => {
          return resolve(updateUserGuideSetting({user_guide_h5_sync: 1}))
        }).then(() => {
          config.enterpirse_wxwork_guide_sync = false
        })
      }
    },
    closeSyncGuide () {
      this.handleSendGuideRequest()
    },
    handleDonwloadSyncGuide () {
      // 企业微信pc引导下载客户端， 如果是企业为第三方应用过来的用户
      if (config.enterpirse_wxwork_guide_sync) {
        return this.handleSendGuideRequest().then(() => {
          window.location.href = 'https://www.fangcloud.com/home/download'
        })
      }
    },
    // 企业微信引导已有账号的的人重新登录
    handleSendLogoutGuideRequest () {
      if (this.config.enterpirse_wxwork_guide_logout) {
        return new Promise((resolve) => {
          return resolve(updateUserGuideSetting({user_guide_h5_logout: 1}))
        }).then(() => {
          config.enterpirse_wxwork_guide_logout = false
        })
      }
    },
    handleLogoutGuideClick () {
      if (config.enterpirse_wxwork_guide_logout) {
        console.log('handleLogoutGuideClick')
        window.location.href = config.logoutUrl
      }
    },
    closeLogoutGuide () {
      this.handleSendLogoutGuideRequest()
      console.log('closeLogoutGuide')
    },
    setTitle (title) {
      setDocumentTitle(title)
    },
    toggleOpenFileNav () {
      const { params, name, query } = this.$route
      const isOpenIndex = name === 'OpenView' && !params.space && !params.id
      if (isOpenIndex) {
        this.$router.push({ query: {...query, filenav: 1} })
      }
    },
    onListInfoChange (info) {
      // console.log(info, 'info', this.headerItem)
      this.listInfo = info
      if (['own', 'collab', 'external'].includes(info.space)) {
        this.headerItem = {...this.headerItem, permissions: info.permissions}
      }
      if (info.space === 'external') {
        this.headerItem.is_frequently_used = info.is_frequently_used
        this.setTitle(this.headerItem.name = info.current_path[0].name)
      }
    },
    onHeaderItemChange (item) {
      this.headerItem = item
      this.setTitle(item.name)
    },
    closeActionSheet () {
      this.$router.go(-1)
    },
    handleReceiveTrashFilterList (list) {
      this.trashFilterList = list
    },
    onPlusClick () {
      this.setState({actionSheet: {
        title: i18n.t('file.menuHeader.addTo', [this.headerItem.name]),
        actions: this.plusActions,
        actionFrom: 'plus'
      }})
    },
    createFolder () {
      if (this.canCreateFolder) {
        this.setState({actionState: {
          action: 'createFolder',
          headerItem: this.headerItem,
          actionName: 'create'
        }})
      }
    },
    uploadAction (isGuideZone = false) {
      // 上传文件呼出文件选择器后取消actionsheet
      this.toggleQuery('actionsheet')
      // 企业微信直接唤起文件选择器
      !isGuideZone && this.closeActionSheet()
      triggerUploadFile(this.handleUpload, this.uploadTarget)
    },
    handleUpload (files) {
      this.uploadFiles = files
    },
    toggleSearch () {
      this.toggleQuery('search')
    },
    handleShowSortAction () {
      this.setState({actionSheet: {
        title: i18n.t('file.sort'),
        actions: this.sortActions,
        actionFrom: 'sort'
      }})
    },
    handleShowTrashFilter () {
      this.setState({actionSheet: {
        actions: this.trashFilterList.map(item => {
          const { name, id, type } = item
          return {
            className: this.trashFilterSelected === id ? 'active' : '',
            key: id,
            name,
            callback: () => {
              this.trashFilterSelected = `${type}_${id}`
              // TODO: toggleQuery 需要继续抽象，接受 params的replace
              const newQuery = {...this.$route.query}
              delete newQuery.actionsheet
              this.$router.replace({ params: { space: this.$route.params.space, id }, query: newQuery })
            }
          }
        }),
        actionFrom: 'trash-filter'
      }})
    },
    saveSortInfo (sortInfo) {
      if (this.store.sortInfo !== sortInfo) {
        this.setState({sortInfo})
      }
      this.closeActionSheet()
    },
    handleSearchInClick (e) {
      this.searchIn = e.target.getAttribute('data-value')
    },
    toggleSelect (item) {
      if (item.selected) {
        this.selectedFiles.push(item)
      } else {
        const index = this.selectedFiles.findIndex(file => file.id === item.id)
        this.selectedFiles.splice(index, 1)
      }
    },
    toggleShowSelectFiles () {
      if (!this.selectDisabled) {
        this.showSelectedFiles = !this.showSelectedFiles
      }
    },
    sendSelectFiles () {
      console.log(this.selectedFiles)
      const data = this.selectedFiles.map(item => ({
        id: item.id,
        user_id: Number(item.user_id),
        name: item.name,
        size: item.size,
        created_at: item.created_at,
        modified_at: item.modified_at,
        type_icon: item.type_icon,
        file_version_key: item.file_version_key,
        thumbnail: item.thumbnail,
        median_thumbnail: item.median_thumbnail
      }))
      // const message = JSON.stringify(data)
      // console.log(message)
      this.showSelectedFiles = false
      openPlatformCallback('selectFiles', data)
      // window.parent.postMessage(JSON.stringify({ type: 'selectFiles', from: 'fangcloud', data }), config.openConfig.origin)
    },
    sendSelectFolder () {
      const isLeaf = this.headerItem.typed_id === 'own_0'
      const data = {
        folder_id: isLeaf ? 0 : this.headerItem.id,
        name: this.headerItem.name,
        isLeaf
      }
      openPlatformCallback('selectDestination', data)
      // window.parent.postMessage(JSON.stringify({ type: 'selectDestination', from: 'fangcloud', data }), config.openConfig.origin)
    },
    closeOpenSelector () {
      openPlatformCallback('close')
      // window.parent.postMessage(JSON.stringify({ type: 'close', from: 'fangcloud' }), config.openConfig.origin)
    },
    handleTabClick (index, props) {
      // 点击协作成员tab标签 增加query查询 值为 tab = collab
      const {tab, ...reset} = this.$route.query

      if (index) {
        this.$router.replace({query: {...this.$route.query, ...{tab: 'collab'}}})
      } else {
        this.$router.replace({query: reset})
      }
    },
    collabListCallback (collabList) {
      this.collabList = collabList
      // 存储到store
      store.invitedCollMemberIds = collabList.map(item => item.user.id)
    }
  }
}
</script>

<style lang="postcss">
@import 'variables';
.file-view.footer-show {
  padding-bottom: 54px;
}

.file-view {
  display: flex;
  flex-direction: column;
  height: 100%;

  & .van-notice-bar {
    background-color: #6ca2ff;
    color: #fff;
  }
  & .notice-login-yellow {
    color: rgb(243, 247, 8);
  }
  & .file-list,
  & .search-empty-state {
    flex: 1 1 auto;
    background-color: #eeeff5;
  }

  & .open-search-list {
    margin-bottom: 50px;
  }

  & .file-list.disable-scroll {
    overflow: hidden;
  }

  & .van-tabs__wrap {
    z-index: 0;
    left: 17%;
    right: 17%;
  }

  & .file-view-tabs {
    width: 100%;
    background-color: #fff;
  }

  & .file-view-list {
    display: flex;
    flex: 1;
    flex-direction: column;
    z-index: 0;
    overflow: auto;

    & .file-list,
    & .search-empty-state {
      flex: 1 1 auto;
      background-color: #eeeff5;
    }

    & .open-search-list {
      margin-bottom: 50px;
    }

    & .file-list.disable-scroll {
      overflow: hidden;
    }

    & .search-view {
      width: 100%;
      height: 100%;

      &.file-search {
        transition: 0s;
      }
    }

    & .plus-action {
      z-index: 1;
      position: fixed;
      bottom: 30px;
      right: 20px;
      border-radius: 50%;
      width: 54px;
      height: 54px;
      text-align: center;
      color:#fff;
      line-height: 54px;
      box-shadow: 0 4px 6px 0 #c1d1ee;
    }

    & .select-action {
      flex: 0 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      line-height: 50px;
      border-top: 1px solid rgba(191, 191, 191, 0.5);
      background-color: #fff;
      padding: 0 15px;
      z-index: 3000;

      &.in-search {
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        bottom: 0;
      }

      & .selected-count {
        font-size: 14px;

        &.disabled {
          color: #d8dbe2;
        }
      }

      & .icon-arrow-down1 {
        font-size: 8px;
      }

      & button {
        min-width: 100px;
        border: 0;
        color: #fff;

        &.btn-select-destination {
          width: 200px;
        }
      }
    }

    & .seleted-popup {
      margin-bottom: 50px;
    }
  }

  & .open_select_files{
    height: 100%;
    transition: 0s;
  }
}

</style>
